// App loader
import appLoader from 'design-system/src/js/00-utilities/app-loader';
import { uaIsMobile } from 'design-system/src/js/00-utilities/ua-sniffing';
import getElementDimensions from '../00-utilities/get-element-dimensions';

function app() {
  let
    btn = document.querySelector( '.menu-btn' ),
    menuContent = document.querySelector( '.menu-content' ),
    menuBarLimit = document.querySelector( '.menu-bar__holder' ).getBoundingClientRect().right,
    categories = document.querySelectorAll( '.menu-category' ),
    overlay = document.createElement( 'DIV' ),
    clickedElement = null;

  overlay.classList.add( 'menu__overlay' );


  if ( categories ) {
    categories.forEach(( category ) => {
      let label = category.querySelector( '.menu-label' );

      // Mouse handling
      if ( !uaIsMobile()) {
        category.addEventListener( 'mouseenter', () => {
          placeSubMenu( category );
        });
      }

      if ( label && uaIsMobile()) {
        // Tap handling
        if ( window.matchMedia( '(max-width: 991px)' ).matches ) {
          label.addEventListener( 'click', () => {
            if ( !label.classList.contains( 'is-open' )) {
              let listHeight =
              getElementDimensions( label.nextElementSibling, null, 'flex' ).h;
              label.classList.add( 'is-open' );
              label.nextElementSibling.classList.add( 'is-open' );
              setTimeout(() => {
                label.nextElementSibling.classList.add( 'is-animated' );
                label.nextElementSibling.style.height = listHeight + 'px';
              }, 8 );
            } else {
              label.nextElementSibling.classList.add( 'is-closing' );
              setTimeout(() => {
                label.classList.remove( 'is-open' );
                label.nextElementSibling.classList.remove(
                  'is-closing',
                  'is-animated'
                );
                label.nextElementSibling.removeAttribute( 'style' );
              }, 151 );
              setTimeout(() => {
                label.nextElementSibling.classList.remove( 'is-open' );
              }, 301 );
            }
          });
        } else if ( window.matchMedia( '(min-width: 992px)' ).matches ) {
          label.addEventListener( 'click', () => {
            if ( !label.classList.contains( 'is-open' )) {
              cleanUpCategoriesState();
              label.classList.add( 'is-open' );
              label.nextElementSibling.classList.add( 'is-open' );
              placeSubMenu( category );
              setTimeout(() => {
                label.nextElementSibling.classList.add( 'is-animated' );
              }, 8 );
              clickedElement = label;
              document.addEventListener( 'click', clickOutsideMenu );
            } else {
              label.nextElementSibling.classList.add( 'is-closing' );
              setTimeout(() => {
                label.classList.remove( 'is-open' );
                label.nextElementSibling.classList.remove(
                  'is-closing',
                  'is-animated'
                );
              }, 151 );
              setTimeout(() => {
                label.nextElementSibling.classList.remove( 'is-open' );
              }, 301 );
            }
          });
        }
      }

    });
  }

  if ( btn ) {
    btn.addEventListener( 'click', () => {

      cleanUpCategoriesState();

      if ( !btn.classList.contains( 'is-open' )) {
        openMenu();
      } else {
        closeMenu();
      }
    });
  }

  function cleanUpCategoriesState() {
    categories.forEach(( category ) => {
      category.querySelector( '.menu-label' )
        .classList.remove( 'is-open' );
      category.querySelector( '.menu-sub-category' )
        .classList.remove( 'is-open' );
    });
  }

  function openMenu() {
    document.body.appendChild( overlay );
    overlay.addEventListener( 'click', () => {
      closeMenu();
    });
    btn.classList.add( 'is-open' );
    menuContent.classList.add( 'is-open' );
    setTimeout(() => {
      overlay.classList.add( 'is-animated' );
      menuContent.classList.add( 'is-animated' );
    }, 8 );
  }

  function closeMenu() {
    menuContent.classList.remove( 'is-animated' );
    btn.classList.remove( 'is-open' );
    overlay.removeEventListener( 'click', closeMenu );
    overlay.classList.remove( 'is-animated' );
    setTimeout(() => {
      menuContent.classList.remove( 'is-open' );
      overlay.remove();
    }, 300 );
  }

  function placeSubMenu( menuItem ) {
    let
      itemData = menuItem.getBoundingClientRect(),
      subMenu = menuItem.querySelector( '.menu-sub-category' ),
      subMenuData = subMenu.getBoundingClientRect(),
      itemCenter = itemData.left + itemData.width / 2,
      subMenuPosition = itemCenter - subMenuData.width / 2;

    if ( subMenu.classList.contains( 'menu-sub-category--2-cols' )
      || subMenu.classList.contains( 'menu-sub-category--1-cols' )) {

      if ( itemCenter + subMenuData.width / 2 < menuBarLimit ) {
        subMenu.style.marginLeft = 'unset';
        subMenu.style.left = subMenuPosition + 'px';
      } else {
        subMenu.style.marginLeft = 'unset';
        subMenu.style.left = ( menuBarLimit - subMenuData.width ) + 'px';
      }
    }
  }

  function clickOutsideMenu() {
    if ( !event.target.closest( '.menu' )) {
      clickedElement.nextElementSibling.classList.add( 'is-closing' );
      setTimeout(() => {
        clickedElement.classList.remove( 'is-open' );
        clickedElement.nextElementSibling.classList.remove(
          'is-closing',
          'is-animated'
        );
      }, 151 );
      setTimeout(() => {
        clickedElement.nextElementSibling.classList.remove( 'is-open' );
      }, 301 );
      document.removeEventListener( 'click', clickOutsideMenu );
    }
  }
}

appLoader({
  polyfillUrls: {
    full: './js/polyfill/polyfill-full.min.js',
    partial: './js/polyfill/polyfill-partial.min.js'
  },
  appCode: app
});
